import React from 'react';
import fukakusa_ken from '../assets/fukakusa_ken.png';
import fukakusa_jo from '../assets/fukakusa_jo.png';
import logo2 from '../assets/logo2.png';
import background from '../assets/background.png';

export default function WeaponsClass() {
  const pageStyle = {
    // 70% white overlay on top of the background image -> image appears ~30% visible
    backgroundImage: `linear-gradient(rgba(255,255,255,0.7), rgba(255,255,255,0.7)), url(${background})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
  };

  const contentStyle = {
    maxWidth: 900,
    margin: '0 auto',
    padding: '32px 16px 48px',
    color: '#111',
    lineHeight: 1.6,
  };

  const sectionStyle = {
    margin: '32px 0',
    paddingBottom: 16,
    borderBottom: '1px solid rgba(0,0,0,0.08)',
  };

  const photoStyle = {
    width: 260,
    maxWidth: '100%',
    display: 'block',
    margin: '0 auto 12px',
    borderRadius: 12,
    boxShadow: '0 8px 20px rgba(0,0,0,0.12)',
  };

  const poweredByStyle = {
    textAlign: 'center',
    marginTop: 40,
  };

  const h1Style = { textAlign: 'center', marginBottom: 24 };
  const h2Style = { textAlign: 'center' };

  return (
    <div className="Instructors" style={pageStyle}>
      <div style={contentStyle}>
        <h1 style={h1Style}>Aiki Ken and Jo</h1>

        <section className="instructor" style={sectionStyle}>
          <img
            style={photoStyle}
            src={fukakusa_ken}
            alt="Aiki Ken and Jo training (photo 1)"
          />

          <h2 style={h2Style}>
            MOTOHIRO FUKAKUSA SHIHAN — 8th Dan, Aikikai (Chief Instructor)
          </h2>

          <p>
            In Aikido, weapon training is not practiced for fighting with weapons, but to deepen
            the understanding of Aiki movement. <strong>Aiki Ken</strong> (wooden sword) and{' '}
            <strong>Aiki Jo</strong> (wooden staff) help students learn correct distance (ma-ai),
            timing, posture, and stable footwork, which directly improves empty-hand technique.
          </p>

          <p>
            Through basic suburi (solo swings), paired kata, and awase (blending exercises),
            practitioners learn how to enter safely, align the body, and control the centerline.
            The principles are the same as taijutsu: relaxed power, efficient movement, and
            harmony rather than collision.
          </p>

          <img
            style={photoStyle}
            src={fukakusa_jo}
            alt="Aiki Ken and Jo training (photo 2)"
          />

          <p>
            At Thai Aikikai, Aiki Ken and Jo practice is taught as a traditional part of training
            to build precision, calm focus, and strong basics. Students progress step-by-step,
            emphasizing safety, correct form, and respect for partners at all times.
          </p>
        </section>

        <footer className="powered-by" style={poweredByStyle}>
          <div>Powered by</div>
          <img
            className="logo2"
            src={logo2}
            alt="New Wave Consulting Group"
            style={{ height: 40, display: 'block', margin: '8px auto' }}
          />
          <div>New Wave Consulting Group</div>
        </footer>
      </div>
    </div>
  );
}
